import React from 'react'
import { css } from 'glamor'
import {SCREENXSMAX} from '/js/variables/breakpoints'
import CommunityInfo from '../community-info'
import DateNav from '../datenav'
import EventInfo from '../event-info'
import EventProgram from '../event-program'
import Header from '../page-header'
import MapLink from '../map-link'
import SharingButtons from '../sharing-buttons'
import VendorsIndex from '../vendors-index'
import './location.scss'

const LocationView = ({ location, aboutCTA, heading, setEvent, event, vendors, program, }) => (
  <article className="location">
    <Header
      backgroundImage={ location.imageUrl }
      heading={ heading }
    />
    <div className="section section--light">
      <div className="row">
        <div className="col-md-3 col-xs-12">
          <hr className="u-hide-md" />
          <SharingButtons
            className={css( { textAlign: 'center' } )}
            shareText={ "Meet me at " + location.name + '!'}
            market={ location }
          />
          <hr className="u-hide-md" />
        </div>
        <div className="col-md-9 col-xs-12 u-order-xs-first u-order-md-default">
          <MapLink
            latitude={ location.latitude }
            longitude={ location.longitude}
            text={`${ location.address }, ${ location.city }`}
          />
          <hr />
          <Linkify tagName="div" className="location__about">{ location.about }</Linkify>
          { aboutCTA &&
            <div className="u-text-center">
              {
                aboutCTA.map( ( cta, index ) => {
                  return (
                    <a key={index} className="button button-big" href={cta.url} target={cta.target}>{cta.text}</a>
                  )
                } )
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div className="section">
      <DateNav
        events={ location.events }
        setEvent={ setEvent }
        event={ event }
        pageLength={ window.innerWidth < SCREENXSMAX ? 1 : 3 }
      />
    </div>
    { program &&
      <div className="section">
        <EventProgram className="location__event-selector"{ ...program } />
      </div>
    }
    <div className="section">
      <CommunityInfo
        className="location__community-info"
        event={ event }
      />
    </div>
    { event ?
      <section className="section">
        <h2 className="highlight">Creators</h2>
        <VendorsIndex vendors={ vendors } market={ location } compactGrid={true} initialPageLength={50} />
      </section> :
      <section className="section">
        <h2 className="highlight">No Events Found</h2>
        <div className="u-text-center">
          <p>No events found at this location.</p>
        </div>
      </section>
    }
  </article>
)

export default LocationView
